import React from "react";
import axios from "axios";
import { Button } from "reactstrap";
import Swal from "sweetalert2";

function BajaMultiple(props) {
  const URL_BAJA = `${props.URL_BAJA}/${props.idStatus}`;
  const URL_BAJA_HIJO = `${props.hijo}/${props.idStatus}`;

  const cambiarStatus = (nuevoEstado) => {
    const texto = nuevoEstado === "Si" ? "Alta" : "Baja";
    Swal.fire({
      title: `¿Estás seguro?`,
      text: `Se dará de ${texto}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Sí, dar de ${texto}!`,
    }).then((result) => {
      if (result.isConfirmed) {
        Promise.all([
          axios.patch(
            URL_BAJA,
            { is_active: nuevoEstado },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          ),
          axios.patch(
            URL_BAJA_HIJO,
            { is_active: nuevoEstado },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          ),
        ])
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: `Se dio de ${texto}`,
              showConfirmButton: false,
              timer: 1500,
            });

            // ✅ Actualizar el estado en el padre
            if (typeof props.onStatusChange === "function") {
              props.onStatusChange(props.idStatus, nuevoEstado);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Ocurrió un error",
              footer: `${error.response?.data || error.message}`,
            });
            console.error(error);
          });
      }
    });
  };

  return (
    <>
      {props.is_active === "Si" ? (
        <Button title="Dar de baja" color="primary" onClick={() => cambiarStatus("No")} size="sm">
          <i className="far fa-check-circle"></i>
        </Button>
      ) : (
        <Button title="Reactivar" color="danger" onClick={() => cambiarStatus("Si")} size="sm">
          <i className="far fa-times-circle"></i>
        </Button>
      )}
    </>
  );
}

export default BajaMultiple;
